import * as React from 'react';
import { connect } from 'react-redux';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ApplicationData from '../../app/aApplicationData'

class ScontoTable extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ScontoTable.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [];
        if (this.props.source && this.props.source === "prodottoCreate") {
            columns = [
                { checkbox: true, field: "checked", visible: this.props.source && this.props.source === "prodottoCreate" },
                { field: 'codCampo', title: 'Id', sortable: 'true' },
                { field: 'valCampo', title: i18n('ARM_CORE_PRODUCT.SHARED.SCONTO_VALORE', 'Valore sconto'), sortable: 'true' },
                { field: 'desDom', title: i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione'), sortable: 'true', },
                { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), sortable: 'true', },
            ]
        } else {
            columns = [
                { field: 'id', title: 'Id', sortable: 'true' },
                { field: 'sconto', title: i18n('ARM_CORE_PRODUCT.SHARED.SCONTO_VALORE', 'Valore sconto'), sortable: 'true', formatter: this.scontoFormatter, },
                { field: 'updateUser', title: i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da'), sortable: 'true', },
                { field: 'updateDate', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA', 'Data ultima modifica'), sortable: 'true', formatter: this.dateFormatter, },
            ]
        }

        $(this.refs.ScontoTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.props.source === null || this.props.source === "" || this.props.source === undefined || this.props.source !== "prodottoCreate" ? this.checkScontoDef(row, $element, field) : null,
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            sortOrder: "desc",
            pagination: true,
        });

        if (this.props.source && this.props.source === "prodottoCreate") {
            this.props.inzializzaModificaSconto().then(
                resolve => {
                    if (this.props.listaSconto !== null && this.props.listaSconto !== undefined) {

                        $(this.refs.ScontoTable).bootstrapTable('load', this.props.listaSconto);
                    }
                }
            )
        } else {
            if (this.props.listaSconto !== null && this.props.listaSconto !== undefined) {
                $(this.refs.ScontoTable).bootstrapTable('load', this.props.listaSconto);
            }
        }
    }

    columnDetail(value, row, index) {
        console.log(this.componentName + " columnDetail: " + index);
        if (value !== undefined && value !== null && value === true) {
            return "Si";
        }
        return "No";
    }

    columnDetailButton(value, row, index) {
        let temp;
        if (value !== undefined && value !== null && value === true) {
            temp = "<button class='btn btn-check btn-sm'><i class='fas fa-check fa-fw'/></button>";
        } else {
            temp = "<button class='btn btn-info btn-sm'><i class='fa fa-pencil'/></button>";
        }
        return temp;
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    checkScontoDef(row, $element, field) {
        this.columnDetail(row, $element, field);
    }

    scontoFormatter(value, row, index) {
        return ApplicationData.domainVal("AI_SCONTO", row.sconto, row.sconto).desDom
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.listaSconto !== this.props.listaSconto) {
            console.log("\t rows: " + (nextProps.listaSconto !== null ? nextProps.listaSconto.length : "NULL"));
            if (nextProps.listaSconto === null) {
                $(this.refs.ScontoTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.ScontoTable).bootstrapTable('load', nextProps.listaSconto);
            }
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card-body">
                <table ref="ScontoTable" className={AppConstants.CLASS_TABLE} />
            </div>
        );
    }

};

function mapStateToProps(state) {
    return {
        prodotto: state.prodotto.detailsProdotto,
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScontoTable);


